/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react"
import type { MBPostProps } from "./post"

const PostFooter = ({ post }: MBPostProps) => null

export default PostFooter
